import { useEffect } from 'react';
import ReactPlayer from 'react-player/file';
import { getInternalPlayer } from 'components/app/_helpers/_app.helper';

export const usePlayerPlay = (ref: React.MutableRefObject<ReactPlayer>, play?: boolean) => {
  useEffect(() => {
    /* 
      NOTE:
      The 'playing' prop does not always work in cases where the value changes quickly,
      for this reason, play/pause are performed directly in the player instance
    */
    const internalPlayer = getInternalPlayer(ref.current);
    if (play === undefined) return;
    if (!internalPlayer) return;
    if (play) internalPlayer.play();
    else internalPlayer.pause();
  }, [play]);
};
